<template>
  <div role="alert">
    <v-icon
      class="gold--text"
      style="font-size: 100px"
    >
      check_circle_outline
    </v-icon>
    <h2 class="secondary--text">
      Thanks!
    </h2>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
